export default "__VITE_ASSET__B_0OZ3Ez__"